/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type AboutUserFormCardBackofficeUserFragment = {
  __typename?: 'BackofficeUser'
  id: string
  email: string
  signInMethod: Types.BackofficeSignInMethod
  signUpStatus: Types.BackofficeSignUpStatus
  gdpr: boolean
  critical: boolean
  username: string
  createDate: string
  lastModifiedDate: string
  organizationId: string
}

export const AboutUserFormCardBackofficeUserFragmentDoc = gql`
    fragment AboutUserFormCardBackofficeUser on BackofficeUser {
  id
  email
  signInMethod
  signUpStatus
  gdpr
  critical
  username
  createDate
  lastModifiedDate
  organizationId
}
    `
